import React from 'react'

import BaseTemplate from 'components/templates/BaseTemplate'
import StickyBasicContent from 'components/organisms/StickyBasicContent'

import Header from './Header'
import AboutKIT from './About'
import Greeting from './Greeting'
import WhyKIT from './WhyKIT'
import WhyCambodia from './WhyCambodia'
import Testimonials from './Testimonials'
import Majors from './Majors'
import EnrollmentSteps from './EnrollmentSteps'
import Scholarships from './Scholarships'
import FAQ from './FAQ'
import MoreInfo from './MoreInfo'

import './Kit.scss'


const KITLanding = () => (
  <BaseTemplate
    firstSection=".kit-header"
    stickyBottomContent={
      <StickyBasicContent
        title="Segera Daftar di Kirirom Institute of Technology sekarang!"
        href="https://goo.gl/4uGSY2"
        buttonText="Daftar Sekarang"
      />
    }
    useStickyBottom
  >
    <div id="kit-page">
      <Header/>
      <Greeting/>
      <AboutKIT/>
      <WhyKIT/>
      <WhyCambodia/>
      <Testimonials/>
      <Majors/>
      <EnrollmentSteps/>
      <Scholarships/>
      <FAQ/>
      <MoreInfo/>
    </div>
  </BaseTemplate>
)

export default KITLanding
